import React, { useState, useEffect } from 'react'
import { compareAsc, format } from 'date-fns'
import moment from "moment";
function MonthSummaryComp({ userId, Attmonth, Attyear }) {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const [month, setMonth] = useState(moment().format('M'))
    const [year, setYear] = useState(moment().format('YYYY'))
    const [error, setError] = useState(null);
    const [weekOff, setWeekOff] = useState(null)
    const [holidays, setHolidays] = useState(null)
    const [leave, setLeave] = useState(null)
    const [present, setPresent] = useState(null)
    const [halfday, setHalfday] = useState(null)
    const [days, setDays] = useState(null)
    const controller = new AbortController();
    const signal = controller.signal; // The signal that we will pass to the fetch request

    const lastDayOfMonth = new Date(Attyear, Attmonth, 0).getDate();




    // console.log(Attyear,Attmonth)
    useEffect(() => {
        let number_of_days = moment(`${Attyear + '-' + Attmonth}`, "YYYY-MM").daysInMonth()
        setDays(number_of_days)
    }, [Attyear, Attmonth])

    useEffect(() => {
        get_present_in_month()
        get_leave_in_month()
        get_week_of_days_in_month()
        get_holidays_in_month()
    }, [Attyear, Attmonth, userId])

    const get_present_in_month = async () => { 
        const response = await fetch(SERVER_URL + `api/attendance/present_in_month`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    empID: userId,
                    currYearName: Attyear,
                    month: Attmonth
                })
            });
        const result = await response.json();
        let presentcount = 0;
        let halfdaycount = 0;
        for (var j = 0; j < result?.data?.length; j++) {

            if (result?.data[j].total_minutes >= 420 && (result?.data[j].day_name !== "Sat" && result?.data[j].day_name !== "Sun")) {
                presentcount = presentcount + 1
            }
            setPresent(presentcount)
            if ((result?.data[j].total_minutes >= 240 && result?.data[j].total_minutes <= 420) && (result?.data[j].day_name !== "Sat" && result?.data[j].day_name !== "Sun")) {
                halfdaycount = halfdaycount + 1
            }
            setHalfday(halfdaycount)
        }


    }
    const get_leave_in_month = async () => {
        const response = await fetch(SERVER_URL + `api/leave/leave-emp-count-total`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    empID: userId,
                    currYearName: Attyear,
                    month: Attmonth
                })
            });
        const result = await response.json();
        setLeave(result?.data?.leave_count)
    }
    const get_holidays_in_month = async () => {
        const response = await fetch(SERVER_URL + `api/common/getholiday?month=${Attmonth}&&year=${Attyear}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            });
        const result = await response.json();
        setHolidays(result?.result?.length || null)
    }

    const get_week_of_days_in_month = () => {
        let weekOfdays = 0;
        for (let i = 1; i < lastDayOfMonth + 1; i++) {
            if (moment(new Date(Attyear, Attmonth - 1, i)).format("ddd") == 'Sun' || moment(new Date(Attyear, Attmonth - 1, i)).format("ddd") == 'Sat') {
                weekOfdays += 1
            }
        }
        setWeekOff(weekOfdays)
    }
    return (
        <div className="dash_white_box2 mb20">
            <div className="dash_white_box_ttl">Monthly Summary</div>
            <table className="monthly_table">
                <thead>
                    <tr>
                        <th colSpan="2">Attendance : <b>1  {moment(new Date(Attyear, Attmonth - 1)).format("MMM YYYY")} - {moment(Attyear + '-' + Attmonth, "YYYY-MM").daysInMonth()} {moment(new Date(Attyear, Attmonth - 1)).format("MMM YYYY")}</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ width: '50%' }}>Present</td>
                        <td>{present ? present : '--'}</td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}>Half Day</td>
                        <td>{halfday ? halfday : '--'}</td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}>Absent</td>
                      
                        <td>{(days - weekOff) - (present ? present : 0) - (holidays ? holidays : 0)-(halfday?halfday/2:0)}</td>
                    </tr>
                    {/* <tr>
                        <td style={{ width: '50%' }}>Late In / Early Out</td>
                        <td>--</td>
                    </tr> */}
                    <tr>
                        <td style={{ width: '50%' }}>Leave</td>
                        <td>{leave ? leave : '--'}</td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}>Weekly off days</td>
                        <td>{weekOff}</td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}>Holiday</td>
                        <td>{holidays ? holidays : '--'}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default MonthSummaryComp
